// extracted by mini-css-extract-plugin
export default {"wrapper":"CompletedIcon_wrapper__DS17J","withCircle":"CompletedIcon_withCircle__d84tq","path":"CompletedIcon_path__lcngu"};